"use client"
import React, { useState, useRef } from 'react'
import { Play, X } from "lucide-react";
import WhyMSUModal from '../WhyMSU/WhyMSUModal';
import chancellerImg from "../../assets/image/chanceller-img.webp";
import Image from 'next/image';


const Aboutsection = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showMore, setShowMore] = useState(false);

    const textRef = useRef(null);

    const videoUrl = "https://example.com/msu-showcase-video.mp4";
    const videoTitle = "Medhavi Skills University Overview";

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const toggleShowMore = () => {
        setShowMore((prev) => !prev);

        // Scroll back to content start
        setTimeout(() => {
            textRef.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }, 150);
    };
    return (
        <section className="w-full mt-8 md:mt-14  bg-white">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-10 ">

                <div ref={textRef} className="space-y-6 lg:mb-0">
                    <div>
                        <h2
                            className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight"
                            style={{ fontFamily: "saans-bold" }}
                        >
                            Shri Pravesh Dudani
                        </h2>

                        <p className="text-[16px] font-semibold leading-snug text-gray-700">
                            Founder & Chancellor, Medhavi Skills University
                        </p>
                    </div>
                    <p className="text-gray-700 text-base sm:text-lg leading-relaxed"
                        style={{ fontFamily: "saans-regular" }}
                    >
                        Welcome to Medhavi Skills University, a place where education is not merely imparted, but purpose is shaped. 
                    
                    </p>

                    <p className="text-gray-700 text-base sm:text-lg leading-relaxed"
                        style={{ fontFamily: "saans-regular" }}
                    >
                        While Medhavi Skills University is recognised by the UGC and acknowledged by national platforms,
                        our true measure of success is not in accolades, but in the journeys we help transform.
                        Every learner who walks through our doors brings with them aspirations, potential,
                        and the hope of a meaningful future. That responsibility lies at the heart of everything we do.
                    </p>

                    <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-0"
                        style={{ fontFamily: "saans-regular" }}
                    >
                        At Medhavi Skills University, we have reimagined education to meet this challenge. Learning here
                        extends far beyond classrooms and examinations. Our programmes are deeply integrated with industry,
                        built around real-world problems, hands-on practice and paid On-the-Job Learning that allows students
                        to earn, learn and grow simultaneously. We believe responsibility is the best teacher and experience
                        the strongest foundation.
                        <br /> <br />

                        Equally important is access. We take pride in being the only university in Sikkim where every eligible
                        student applicant receives a government scholarship, because talent exists everywhere and opportunity must too.
                        No dream should be limited by circumstance.

                        {!showMore && (
                            <button
                                onClick={toggleShowMore}
                                className="inline text-[#FFA201] text-sm sm:text-base ml-1 hover:underline cursor-pointer"
                            >
                                Show More
                            </button>
                        )}
                    </p>

                    <div className={`overflow-hidden transition-all duration-500 ease-in-out 
                    ${showMore ? "max-h-[2000px]" : "max-h-0"}`}
                    >
                        <div className="space-y-2">
                            <p className="text-gray-700 text-base sm:text-lg leading-relaxed"
                                style={{ fontFamily: "saans-regular" }}
                            >
                                With advanced laboratories, robust placement support and continuous industry exposure, our aim is simple yet
                                profound: that every graduate leaves MSU not only with a degree, but with clarity of purpose, confidence in ability,
                                and readiness for the future.
                            </p>
                            <p className="text-gray-700 text-base sm:text-lg leading-relaxed"
                                style={{ fontFamily: "saans-regular" }}
                            >
                                Having studied and taught across leading institutions in India and abroad, I remain convinced that true
                                education prepares one not just for a first job, but for a lifetime of learning, adaptability and leadership.
                            </p>
                            <p className="text-gray-700 text-base sm:text-lg leading-relaxed"
                                style={{ fontFamily: "saans-regular" }}
                            >
                                At Medhavi Skills University, you are not merely students—you are partners in progress.
                                You are the builders of industries, communities and a stronger, more capable nation. In shaping your future,
                                you are also shaping the future of a Viksit Bharat.
                                {showMore && (
                                    <button
                                        onClick={toggleShowMore}
                                        className="text-[#FFA201] text-sm sm:text-base hover:underline ml-2 cursor-pointer"
                                    >
                                        Show Less
                                    </button>
                                )}
                            </p>
                        </div>
                    </div>
                </div>


                <div className="w-full md:mt-20">
                    <div
                        className="relative w-full h-[400px] md:h-[530px]  overflow-hidden
                        border border-gray-100  group
                        transform hover:scale-[1.01] transition duration-500
                        ease-in-out bg-gray-200 flex items-center justify-center"
                    // onClick={openModal}
                    // role="button"
                    // aria-label={`Watch video: ${videoTitle}`}
                    >
                        <Image
                            src={chancellerImg}
                            alt="Video Thumbnail"
                            fill
                            priority
                            className="object-cover  w-full transition-opacity duration-500
                            group-hover:opacity-80 opacity-100"
                        />

                        {/* <div className="relative z-10 size-14 rounded-full bg-white/90
                        backdrop-blur-sm flex items-center justify-center shadow-2xl
                        transform group-hover:scale-110 transition-transform duration-300">
                            <Image
                                src="/play.svg"
                                alt="Play"
                                width={18}
                                height={22}
                                className="ml-1.5 hover:ml-1.5"
                            />
                        </div> */}
                    </div>
                </div>

            </div>

            {isModalOpen && (
                <WhyMSUModal
                    videoUrl={videoUrl}
                    videoTitle={videoTitle}
                    setOpen={closeModal}
                />
            )}
        </section>
    );
}

export default Aboutsection;